import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../lib/api.js'
import { DataTable, Pager } from '../components/DataTable.jsx'

const fmtDate = (v) => (v ? new Date(v).toLocaleDateString('tr-TR') : '-')

function ageLabel(birthDate) {
  const months = Math.floor((Date.now() - new Date(birthDate)) / (30.4375 * 86_400_000))
  if (months < 24) return `${months} ay`
  return `${Math.floor(months / 12)} yas`
}

export function Children() {
  const [q, setQ] = useState('')
  const [page, setPage] = useState(1)
  const [res, setRes] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    const t = setTimeout(() => {
      const params = new URLSearchParams({ page, limit: 25, ...(q ? { q } : {}) })
      api(`/admin/children?${params}`)
        .then(setRes)
        .catch((e) => setError(e.message))
    }, 250)
    return () => clearTimeout(t)
  }, [q, page])

  const columns = [
    { key: 'full_name', label: 'Ad' },
    { key: 'sex', label: 'Cinsiyet' },
    { key: 'birth_date', label: 'Dogum', render: (c) => fmtDate(c.birth_date) },
    { key: 'age', label: 'Yas', render: (c) => ageLabel(c.birth_date) },
    { key: 'measurement_count', label: 'Olcum' },
    {
      key: 'user_email',
      label: 'Ebeveyn',
      render: (c) => <Link to={`/users/${c.user_id}`}>{c.user_email}</Link>,
    },
  ]

  return (
    <>
      <h1>Cocuklar</h1>
      {error && <div className="alert">{error}</div>}
      <input
        className="search"
        placeholder="Cocuk adi veya ebeveyn e-postasi ara..."
        value={q}
        onChange={(e) => {
          setQ(e.target.value)
          setPage(1)
        }}
      />
      <DataTable columns={columns} rows={res?.data} />
      <Pager meta={res?.meta} onPage={setPage} />
    </>
  )
}
